/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";
import { assetImages } from "constants";

const AfterSaveUserModal = ({ userId, afterSaveModalClose, moduleName }) => {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  // const moduleAccess = localStorage.getItem("moduleaccess") || "";

  const userHasPremission = ["ADMIN", "SUPER_ADMIN"].includes(
    userInfo.role?.slug
  );

  return (
    <div
      className="modal fade"
      id="afterSaveUserModal"
      tabIndex="-1"
      aria-labelledby="saveInfoLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-body text-center p-5">
            <img
              src={assetImages.congratulationsIcon}
              alt="You have saved a lead successfuly."
              className="img-fluid mb-2"
            />
            <h2 className="mb-2">Congratulations</h2>
            <p className="fs-lg fw-semibold mb-5">
              You have {userId ? "update" : "added"}{" "}
              {moduleName === "CV" ? "cv" : "profile"} successfuly.
            </p>
            <div className="action d-flex justify-content-center gap-3">
              <Link
                to="#"
                data-bs-dismiss="modal"
                className={
                  userHasPremission ? "btn btn-outline-primary" : "d-none"
                }
                onClick={() => {
                  afterSaveModalClose("list");
                }}
              >
                Go to List
              </Link>
              <Link
                to="#"
                data-bs-dismiss="modal"
                className="btn btn-primary"
                onClick={() => {
                  afterSaveModalClose("details");
                }}
              >
                Preview Details
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AfterSaveUserModal;
